import React from 'react';
const facts = [{
  value: '300',
  label: 'Ready-to-use pages across 6 volumes',
  tint: 'bg-teal-soft'
}, {
  value: '24+',
  label: 'Ready-to-teach Class Plans',
  tint: 'bg-peach-soft'
}, {
  value: '17',
  label: 'Full routines written in 8-counts',
  tint: 'bg-sage-soft'
}, {
  value: '30',
  label: 'Printable worksheets (WS-01 to WS-30)',
  tint: 'bg-lav-soft'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white" data-id="element-288" data-mp="32jd08pmjrihj">
      <div className="mx-auto max-w-6xl px-5 pb-14 sm:pb-16" data-id="element-289" data-mp="32h0jgfsize62">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-290" data-mp="2xl352f0tohvx">
          {facts.map(fact => <div key={fact.label} className={`rounded-2xl px-4 py-5 text-center ${fact.tint}`} data-id="element-291" data-mp="2thdj7xbj8eel">
              <div className="font-display text-3xl leading-none text-navy sm:text-4xl" data-id="element-292" data-mp="2oiabu682xw3g">{fact.value}</div>
              <div className="mt-2 text-xs font-semibold text-navy-soft" data-id="element-293" data-mp="1i41954p6izjz">{fact.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}